import React, { useEffect, useRef, useState } from "react";
import { Check, ChevronDown } from "lucide-react";

export default function ModelPicker({ value, models, onChange }) {
  const [open, setOpen] = useState(false);
  const root = useRef(null);
  const trigger = useRef(null);
  const menu = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const dismiss = event => { if (!root.current?.contains(event.target)) setOpen(false); };
    const escape = event => {
      if (event.key === "Escape") { event.stopPropagation(); setOpen(false); trigger.current?.focus(); }
    };
    const options = menu.current?.querySelectorAll('[role="menuitemradio"]');
    (Array.from(options || []).find(option => option.getAttribute("aria-checked") === "true") || options?.[0])?.focus();
    document.addEventListener("pointerdown", dismiss);
    document.addEventListener("keydown", escape);
    return () => {
      document.removeEventListener("pointerdown", dismiss);
      document.removeEventListener("keydown", escape);
    };
  }, [open]);

  return <div className="model-picker composer-model-picker" ref={root}>
    <button type="button" ref={trigger} aria-label={`选择模型：${value || "加载中"}`} aria-haspopup="menu" aria-expanded={open}
      title={value || "选择模型"} onClick={() => setOpen(!open)} onKeyDown={event => {
        if (event.key === "ArrowDown" || event.key === "ArrowUp") { event.preventDefault(); setOpen(true); }
      }}>
      <span>{value || "加载模型..."}</span><ChevronDown size={14} className={open ? "rotate" : ""} />
    </button>
    {open && <div className="model-menu" ref={menu} role="menu" aria-label="可用模型" onKeyDown={event => {
      const options = Array.from(menu.current.querySelectorAll('[role="menuitemradio"]'));
      if (!options.length) return;
      const index = options.indexOf(document.activeElement);
      const next = event.key === "ArrowDown" ? (index + 1) % options.length : event.key === "ArrowUp" ? (index + options.length - 1) % options.length : event.key === "Home" ? 0 : event.key === "End" ? options.length - 1 : null;
      if (next !== null) { event.preventDefault(); options[next].focus(); }
    }}>
      {models.length === 0 && <span className="model-menu-empty">暂无可用模型</span>}
      {models.map(model => <button key={model} type="button" role="menuitemradio" aria-checked={value === model}
        className={value === model ? "active" : ""} onClick={() => { onChange(model); setOpen(false); trigger.current?.focus(); }}>
        <span>{model}</span>{value === model && <Check size={14} aria-hidden="true" />}
      </button>)}
    </div>}
  </div>;
}
